import { gql } from '@apollo/client';
import { GqlSeason, GqlSeasonFragment } from '../fragments/season';

export interface Data {
  seasons: Array<GqlSeason>;
}

export const QUERY_BY_PROGRAM = gql`
  query Seasons($programId: ID, $isArchived: Boolean) {
    seasons(filter: { programId: $programId, isArchived: $isArchived }) {
      ...SeasonFields
    }
  }
  ${GqlSeasonFragment}
`;

export const QUERY = gql`
  query Seasons($programId: ID, $organizationId: ID, $isArchived: Boolean) {
    seasons(filter: { programId: $programId, organizationId: $organizationId, isArchived: $isArchived }) {
      ...SeasonFields
    }
  }
  ${GqlSeasonFragment}
`;

export const QUERY_WITH_PROGRAM = gql`
  query Seasons($programId: ID, $organizationId: ID) {
    seasons(filter: { programId: $programId, organizationId: $organizationId }) {
      ...SeasonFields
      program {
        id
        name
      }
    }
  }
  ${GqlSeasonFragment}
`;

export default QUERY;
